import { render, staticRenderFns } from "./DocumentUpload.vue?vue&type=template&id=9404e2b4&"
import script from "./DocumentUpload.vue?vue&type=script&lang=ts&"
export * from "./DocumentUpload.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports